<template>
  <div class="login" key="fade">
    <transition
      enter-active-class="animated zoomInNew"
      leave-active-class="animated zoomOutRight"
      :duration="{ enter: 1000 }"
    >
      <div class="login-wrapper animated" v-show="show" key="bounce">
        <div class="login-main">
          <div class="register-header">
            <img src="../../assets/images/login/header.png" />
          </div>
          <div class="register-box">
            <ul :class="'tab-bar tab-bar-' + loginWays.length">
              <li
                v-for="(way, idx) in loginWays"
                :key="idx"
                :class="activeIdx === way.id ? 'active' : ''"
                @click="changeWay(way.id, idx)"
              >
                {{ way.name }}
              </li>
            </ul>
            <ul
              :class="
                'form move-' +
                (moveIdx + 1) +
                (activeIdx === 2 ? ' channel-form' : '') +
                (noRoleName ? ' no-role-name' : '')
              ">
              <!-- 短信登陆 -->
              <li v-if="formShow[0]" class="sms_login">
                <div>
                  <label for="">
                    <span>手机</span>
                    <input
                      type="text"
                      name=""
                      v-model="inputData.phone"
                      placeholder="请输入手机号码"
                      @focus="inputFocus()"
                      @focusout="inputFocusOut"
                    />
                  </label>
                </div>
                <div>
                  <label for="">
                    <span>验证码</span>
                    <input
                      maxlength="6"
                      v-model="inputData.sms_code"
                      placeholder="请输入验证码"
                      @focus="inputFocus()"
                      @focusout="inputFocusOut"
                    />
                    <div class="timer" @click="getCode" :disabled="disabled">
                      {{ countdown }}
                      <b v-show="timestatus">秒</b>
                    </div>
                  </label>
                </div>
                <div class="btn" @click="login()">登录</div>
                <div class="tips">
                  <div v-if="isOnline == 0" class="link-b" title="未上线"></div>
                  <a
                    v-else
                    class="link-a"
                    :href="downloadUrl"
                    title="前往官网下载"
                  >
                    前往官网下载
                  </a>
                </div>
              </li>
              <!-- 密码登录 -->
              <li v-if="formShow[1]" class="password_login">
                <div>
                  <label for="">
                    <span>账号</span>
                    <input
                      type="text"
                      v-model="inputData.account"
                      placeholder="请输入账号"
                      @focus="inputFocus()"
                      @focusout="inputFocusOut"
                    />
                  </label>
                </div>
                <div>
                  <label for="">
                    <span>密码</span>
                    <input
                      type="text"
                      v-model="inputData.password"
                      placeholder="请输入密码"
                      @focus="inputFocus()"
                      @focusout="inputFocusOut"
                      style="-webkit-text-security: disc; text-security: disc"
                    />
                  </label>
                </div>
                <div class="btn" @click="login()">登录</div>
                <div class="tips">
                  <a class="link-a" :href="downloadUrl" title="前往官网下载">
                    前往官网下载
                  </a>
                </div>
              </li>
              <!-- 渠道用户 -->
              <li v-if="formShow[2]" class="channel_login">
                <div v-if="!noRoleName">
                  <label for="">
                    <span>昵称</span>
                    <input
                      class="inp-role-name"
                      type="role-name"
                      placeholder="角色昵称"
                      v-model="inputData2.role_name"
                      @focus="inputFocus()"
                      @focusout="inputFocusOut"
                    />
                  </label>
                </div>
                <div>
                  <label for="">
                    <span>角色ID</span>
                    <input
                      class="inp-role-id"
                      type="role-id"
                      placeholder="角色ID"
                      v-model="inputData2.role_id"
                      @focus="inputFocus()"
                      @focusout="inputFocusOut"
                    />
                  </label>
                </div>
                <div>
                  <label for="">
                    <span>渠道</span>
                    <select
                      name="public-choice"
                      v-model="inputData2.platform"
                      @focus="inputFocus()"
                      @focusout="inputFocusOut"
                    >
                      <option
                        :value="device.id"
                        v-for="device in deviceList"
                        :key="device.id"
                      >
                        {{ device.name }}
                      </option>
                    </select>
                  </label>
                </div>
                <div class="btn binding-btn" @click="login()">绑定角色</div>
                <p class="tips center">{{ channelTips }}</p>
              </li>
            </ul>
          </div>
          <div class="close-btn" @click="changeLoginPopup(false)">
            <img
              src="../../assets/images/login/close_icon.png"
              alt="关闭按钮"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { Toast, Indicator } from "mint-ui";
import { mapMutations } from "vuex";
import { APP_ID, PAGE_ID, SMS_GAME_ID } from "@/config/constant";
import {
  GetCodeAPI,
  LoginBySmsAPI,
  LoginByAccountAPI,
  LoginBySmsFreeAPI,
  LoginByAccountFreeAPI,
  LoginByChannelAPI,
} from "@/api/login";
import _ from "lodash";

const CHANNEL_LIST = {
  snail: [
    { id: "0", name: "请选择渠道" },
    { id: "huawei", name: "华为" },
    { id: "vivo", name: "vivo" },
    { id: "oppo", name: "oppo" },
    { id: "mi", name: "小米" },
    { id: "bilibili", name: "哔哩哔哩" },
    { id: "honor", name: "荣耀" },
  ],
  tideng: [
    { id: "0", name: "请选择渠道" },
    { id: "bilibili", name: "哔哩哔哩" },
  ],
  servitor: [
    { id: "0", name: "请选择渠道" },
    { id: "bilibili", name: "哔哩哔哩" },
  ],
  travel: [
    { id: "0", name: "请选择渠道" },
    { id: "bilibili", name: "哔哩哔哩" },
  ],
  hjwq: [
    { id: "0", name: "请选择渠道" },
    { id: "qdzsf", name: "渠道正式服" },
    { id: "bilibili", name: "BiliBili服" },
    { id: "qdxqf", name: "渠道先遣服" },
    { id: "xqf", name: "先遣服" },
  ],
  hjwq2: [
    { id: "bilibili", name: "BiliBili服" },
  ],
  sakura: [
    { id: "0", name: "请选择渠道" },
    { id: "bilibili", name: "哔哩哔哩" },
  ],
  qscy: [
    { id: "0", name: "请选择渠道" },
    { id: "bilibili", name: "哔哩哔哩" },
  ],
  mzzg: [
    { id: "0", name: "请选择渠道" },
    { id: "bilibili", name: "渠道服" },
  ],
  ares: [
    { id: "0", name: "请选择渠道" },
    // { id: "ios", name: "iOS" },
    { id: "huawei", name: "华为" },
    { id: "vivo", name: "vivo" },
    { id: "oppo", name: "oppo" },
    { id: "mi", name: "小米" },
    { id: "bilibili", name: "哔哩哔哩" },
    { id: "honor", name: "荣耀" },
    { id: "4399", name: "4399" },
    { id: "jiuyou", name: "九游" },
    { id: "ld", name: "雷电" },
    { id: "yyb", name: "应用宝" },
  ],
};

const LOGIN_WAYS = [
  { id: 0, key: "sms", name: "短信登录" },
  { id: 1, key: "password", name: "密码登录" },
  { id: 2, key: "channel", name: "渠道用户" },
];

export default {
  name: "Login",
  components: {},
  data() {
    return {
      show: false,
      loginWays: [], // 顶部文字
      activeIdx: 0, // 选择的登陆方法
      moveIdx: 0,
      formShow: [],
      inputData: {
        //  输入框内容
        account: "",
        password: "",
        phone: "",
        sms_code: "",
      },
      inputData2: {
        role_name: "",
        role_id: "",
        platform: "",
      },
      deviceList: [],

      disabled: false, //  发送验证码是否可点击
      countdown: "发送", //  获取验证码
      timestatus: false, //  是否显示秒
      clear: null, // 清除定时器
    };
  },
  props: {
    gameName: {
      type: String, // 传入参数：snail | tideng | travel | servitor | hjwq | sakura
      required: true,
      default: "",
    },
    downloadUrl: {
      type: String,
      required: true,
      default: "",
    },
    freeLogin: {
      type: Boolean,
      required: false,
      default: false,
    },
    game_id: {
      type: String, // 传入参数：snail | tideng | travel | servitor | hjwq | sakura
      required: false,
      default: "",
    },
    channelTips: String,
    loginTypes: Array,
    autoOpenOS: {
      type: Boolean,
      default: true,
    },
    noAuthLogin: {
      type: Boolean,
      required: false,
      default: false,
    },
    isOnline: {
      type: Number,
      default: 0,
    },
    noRoleName: {
      type: Boolean,
      required: false,
      default: false,
    },
    channelDist: {
      type: [Number, String],
      default: null,
    }

  },
  created() {
    // 根据props修改登录方式
    const formShow = Array.from(new Array(3), (item) => true);
    if (!this.loginTypes || JSON.stringify(this.loginTypes) === "[]") {
      this.loginWays = LOGIN_WAYS;
    } else {
      this.loginWays = LOGIN_WAYS.filter((item, idx) => {
        const result = this.loginTypes.includes(item.key);
        formShow[idx] = result;
        return result;
      });
    }
    this.activeIdx = this.loginWays[0].id;
    this.formShow = formShow;

    // 渠道服
    const deviceList = CHANNEL_LIST[this.gameName];
    this.deviceList = deviceList;
    this.inputData2.platform = deviceList[0].id;
    this.show = true;
  },
  beforeDestroy() {
    this.show = false;
  },
  watch: {
    gameName: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          const deviceList = CHANNEL_LIST[newValue];
          this.deviceList = deviceList;
          this.inputData2.platform = deviceList[0].id;
        }
      },
    },
  },
  methods: {
    // 移动端键盘调用
    inputFocus() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    inputFocusOut() {
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },

    // 登陆方式切换
    changeWay(index, moveIdx) {
      this.activeIdx = index;
      this.moveIdx = moveIdx;
      this.inputData = {
        account: "",
        password: "",
        phone: "",
        sms_code: "",
      };
      this.inputData2 = {
        role_name: "",
        role_id: "",
        platform: 0,
      };
    },

    // 获取验证码
    getCode() {
      // if (!/^1[3456789]\d{9}$/.test(this.inputData.phone)) {
      //   return Toast({
      //     message: "请输入正确的手机号码",
      //     duration: 1000,
      //     className: "toasts"
      //   });
      // }
      Indicator.open();
      GetCodeAPI({
        mobile: this.inputData.phone,
        channel: "login",
        game_id: this.game_id || SMS_GAME_ID[this.gameName]
      })
        .then((response) => {
          if (response.code === 200) {
            this.timestatus = true;
            this.disabled = true; // 禁用点击
            this.countdown = 60;
            this.clear = setInterval(this.countDown, 1000);
          }
        })
        .finally(() => Indicator.close());
    },

    // 倒计时
    countDown() {
      const that = this;
      if (!that.countdown) {
        that.disabled = false;
        that.timestatus = false;
        that.countdown = "发送";
        clearInterval(that.clear);
      } else {
        --that.countdown;
      }
    },

    // 登陆
    login: _.throttle(
      function () {
        const requests = [
          this.freeLogin ? LoginBySmsFreeAPI : LoginBySmsAPI,
          this.freeLogin ? LoginByAccountFreeAPI : LoginByAccountAPI,
          LoginByChannelAPI,
        ];
        const callbacks = [
          this.accountLoginCallback,
          this.accountLoginCallback,
          this.channelLoginCallback,
        ];
        let data = this.getLoginData();
        // 开始验证
        const verifyResult = this.verifyInfo(data);
        if (!verifyResult) {
          return false;
        }
        Indicator.open();
        requests[this.activeIdx]({
          ...data,
          game_id: this.game_id || undefined,
          empower: this.noAuthLogin ? 1 : undefined,
          ...(this.channelDist ? { dist: this.channelDist } : {}), //渠道服dist
        })
          .then((response) => {
            if (response.code === 200) {
              window.localStorage.setItem("access_token", response.data.uuid);
              this.$emit("selectCallback", response);
              callbacks[this.activeIdx](data);
            }
          })
          .finally(() => Indicator.close());
      },
      1000,
      { trailing: false }
    ),

    // 生成对应数据
    getLoginData() {
      let data = { ...this.inputData };
      if (this.activeIdx === 2) {
        data = {
          ...this.inputData2,
          dist: APP_ID[this.gameName],
          page_id: PAGE_ID[this.gameName],
          app_id: APP_ID[this.gameName],
        };
      } else if (this.activeIdx === 0) {
        data.account = data.phone;
      }
      return data;
    },

    // 检验
    verifyInfo(data) {
      switch (this.activeIdx) {
        case 0:
          // if (!/^1[3456789]\d{9}$/.test(this.inputData.phone)) {
          //   Toast({
          //     message: "请输入正确的手机号码",
          //     duration: 1000,
          //     className: "toasts"
          //   });
          //   return false;
          // } else
          if (!data.sms_code) {
            Toast({
              message: "请输入您的验证码",
              duration: 1000,
              className: "toasts",
            });
            return false;
          }
          break;
        case 1:
          if (!data.account) {
            Toast({
              message: "请输入您的账号",
              duration: 1000,
              className: "toasts",
            });
            return false;
          } else if (!data.password) {
            Toast({
              message: "请输入您的密码",
              duration: 1000,
              className: "toasts",
            });
            return false;
          }
          break;
        case 2:
          if (!data.role_name && !this.noRoleName) {
            Toast({
              message: "请输入您的角色昵称",
              duration: 1000,
              className: "toasts",
            });
            return false;
          } else if (!data.role_id) {
            Toast({
              message: "请输入您的角色ID",
              duration: 1000,
              className: "toasts",
            });
            return false;
          } else if (!data.platform || data.platform === "0") {
            Toast({
              message: "请选择渠道",
              duration: 1000,
              className: "toasts",
            });
            return false;
          }
          break;
      }
      return true;
    },

    accountLoginCallback(value) {
      console.log("登录A", value);
      this.$emit("loginCallback");
      this.$emit("loginSuccess");
      this.changeLoginPopup(false);
      if (this.autoOpenOS) {
        this.changeOsPopup(true);
      }
      console.log("userInfo: ", value);
      this.setUserInfo({ ...value });
    },
    channelLoginCallback(params) {
      this.setUserInfo({ ...params });
      this.$emit("channelCallback");
      this.$emit("loginSuccess");
      this.changeLoginPopup(false);
    },
    ...mapMutations(["setUserInfo", "changeLoginPopup", "changeOsPopup"]),
  },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue